
import React, { useEffect, useState, useRef } from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Modal, Stack, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import Axios from 'axios';
import PageLoader from "../commoncomponents/PageLoader";
import "../../assets/css/reports.css";
import "../../assets/css/assetreport.css";
import { DefaultCard } from "../../assets/styled-components/card";
import { getAuthToken } from "../../utility/tokenUtility";
import PageTitle from "../commoncomponents/PageTitle";
import CustomAgGrid from '../commoncomponents/CustomAgGrid';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import axios from 'axios';
import { BemsGraph, FemsGraph, MasterGraph } from '../../utility/apiURLS';
import { ErrorChips, SuccessChips, WarningChips } from '../../assets/styled-components/chips';
import RefreshExportButtons from '../commoncomponents/RefreshExportButtons';
import SectionTitle from '../commoncomponents/SectionTitle';
import CustomSelectInput from '../commoncomponents/CustomSelectInput';
import CustomTextField from '../commoncomponents/CustomTextField';
import CustomTextFieldWithSearch from '../commoncomponents/CustomTextFieldWithSearch';
import CustomDialog from '../commoncomponents/CustomDialog';
import { useAccess } from '../../AccessContext';
import utilities from '../../utility/utilities';
const AssetCheckin = () => {
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [rowsid, setRowsId] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [workorderlistloading, setWorkorderListLoading] = useState(false);
    const [workorderrows, setWorkorderRows] = useState([]);
    const [gridApi, setGridApi] = useState({});
    const [gridApiList, setGridApiList] = useState({});
    const [loading, setLoading] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [transferdialogOpen, setTransferDialogOpen] = useState(false);
    const token = getAuthToken("id_token");
    const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
    const [errorDialogOpen, setErrorDialogOpen] = useState(false);
    const [assetNo, setAssetNo] = useState("");
    const [dialogContent, setDailogContent] = useState("");
    const facilityid = localStorage.getItem("facilityId");
    const accessData = useAccess();
    const access = utilities.getScreenPermissions(accessData, "ENGM015");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const [basicDetailsdata, setBasicDetailsdata] = useState(
        {
            locationName: '',
            locationNo: '',
            userDepartment: '',
            departmentDescription: '',

        }
    );
    const [basicDetailsOptions, setBasicDetailsOptions] = useState(
        {
            locationNameOptions: [],
        }
    );
    const [error, setError] = useState({
        locationName: false
    });
    const [errorMessage, setErrorMessage] = useState({
        locationName: ""
    });

    const handleOnChange = (value, name) => {
        // Update the basicDetailsdata state
        setBasicDetailsdata((previousValue) => ({
            ...previousValue,
            [name]: value,  // Dynamically set the value for the field by name
        }));

        // Reset error and error message for the specific field
        setError((prevError) => ({
            ...prevError,
            [name]: false,  // Dynamically reset error for the specific field
        }));

        setErrorMessage((prevErrorMessage) => ({
            ...prevErrorMessage,
            [name]: "",  // Dynamically reset error message for the specific field
        }));
        
    };


    const columns = [
        { field: "assetno", headerName: "Asset No" },
        { field: "workgroupcode", headerName: "WG Code" },
        { field: "workgroupdesc", headerName: "WG Desc" },
        { field: "assetstatus", headerName: "Asset Status" },
        { field: "service", headerName: " Service" },
        { field: "oldHospital", headerName: "Old Hospital" },
        { field: "newHospital", headerName: "New Hospital" },
        { field: "transferredby", headerName: "Transfer By" },
        { field: "transferreddate", headerName: "Transfer Date" },
        { field: "approvedby", headerName: "Approve By" },
        { field: "approveddate", headerName: "Approve Date" },
        ...(access?.canAuthorize ? [
            {
                field: "approveRejectTransfer",
                headerName: "Approve / Reject Transfer",
                minwidth: 280,
                maxWidth: 280,
                cellRenderer: (params) => {
                    return (
                        <div style={{ display: 'flex', gap: '30px' }}>
                            <Button
                                variant="contained"
                                color="success"
                                size="small"
                                sx={{ minWidth: 50 }}
                                onClick={() => handleApprove(params.data)}
                            >
                                <CheckCircleIcon />
                            </Button>

                            {/* <Button
                            variant="contained"
                            color="error"
                            size="small"
                            sx={{ minWidth: 50 }}
                            onClick={() => handleReject(params.data)}

                        >
                            <CancelIcon />
                        </Button> */}
                        </div>
                    );
                }
            }
        ] : [])

    ];



    useEffect(() => {
        fetchNewAssetTransferList();
    }, []);

    const fetchNewAssetTransferList = async () => {
        setRows([]);
        setIsLoading(true);

        try {
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            // Fetch data from both endpoints concurrently
            const [femResponse, bemResponse] = await Promise.all([
                axios.get(
                    `${FemsGraph}/api/AssetTransfer/FemNewAssetTransferCheckOut/${facilityid}/${token}`,
                    config
                ),
                axios.get(
                    `${BemsGraph}/api/AssetTransfer/BemNewAssetTransferCheckOut/${facilityid}/${token}`,
                    config
                ),
            ]);


            // Combine data from both responses
            const combinedData = [
                ...femResponse.data,
                ...bemResponse.data,
            ];


            setRows(combinedData);
        } catch (error) {
            console.error("Error fetching data", error);
        } finally {
            setIsLoading(false);
        }
    };


    const handleCancel = () => {

        navigate("/dashboard");
        setBasicDetailsdata({});
        setBasicDetailsOptions((prev) => ({
            ...prev,
            locationNameOptions: []
        }));
        setDialogOpen(false);
    };

    const handleDialogClose = () => {
        setBasicDetailsdata({});
        setBasicDetailsOptions((prev) => ({
            ...prev,
            locationNameOptions: []
        }));
        setDialogOpen(false);
    }

    const ErrorDailogclose = () => {
        setBasicDetailsdata({});
        setBasicDetailsOptions((prev) => ({
            ...prev,
            locationNameOptions: []
        }));
        setErrorDialogOpen(false);

    }


    const handleRefresh = () => {
        fetchNewAssetTransferList();
        setBasicDetailsdata({});
        setBasicDetailsOptions((prev) => ({
            ...prev,
            locationNameOptions: []
        }));
        setDialogOpen(false);
    };

    const handleApprove = (rowData) => {
        setDialogOpen(true);
        setRowsId(rowData);
        fetchOptions();

    }

    const handleCloseModel = () => {
        fetchNewAssetTransferList();
        setOpenSuccessDialog(false);
    }
    const handlecontinue = () => {
        navigate("/ppmplanner")
    }
    const handleTransfer = async (rowData) => {

        if (!basicDetailsdata?.locationName?.id) {
            setError({
                locationName: true,
            });
            setErrorMessage({
                locationName: "Location is Required",
            });
            return;
        }
        try {
            const token = getAuthToken("id_token");

            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            const payload = {
                id: rowsid.id,
                Approveby: localStorage.getItem("UserName"),
                Locationid: basicDetailsdata?.locationName?.id,
                ApprovedId: localStorage.getItem("UserId"),
                Token: token,
                Approve: 1,
            };

            const url =
                rowsid.service === "FEMS"
                    ? `${FemsGraph}/api/AssetTransfer/updateNewAssetTransferstatus`
                    : `${BemsGraph}/api/AssetTransfer/updateNewAssetTransferstatus`;

            const response = await axios.post(url, payload, config);

            // ✅ Success (2xx)
            if (response.status >= 200 && response.status < 300) {
                setDialogOpen(false);
                setOpenSuccessDialog(true);
                setAssetNo(response?.data[0]?.assetno);
            }

        } catch (error) {
            setDialogOpen(false);
            setErrorDialogOpen(true);

            const errorMessage =
                error?.response?.data?.detail ||
                "Something went wrong. Please try again.";

            setDailogContent(errorMessage);
            console.error("Error updating asset transfer:", error);
        }
    };



    const fetchOptions = async () => {

        try {
            setLoading(true);
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };


            // Asset Options
            try {
                const locationOptions = await axios.get(`${MasterGraph}/api/CommonExport/CommonExportData/${facilityid}/Location?filterOptions=[]&sortOptions=[]`, config);



                // Location Name Options
                const locationNameOptions = locationOptions?.data?.userLocationVMs?.map((item, index) => ({
                    id: item?.id,
                    key: `option${index}`,
                    label: `${item?.locationcode} - ${item?.locationdesc}`,
                    value: item?.locationcode,
                    locationCode: item?.locationcode,
                    desc: item?.locationdesc,
                    deptCode: item?.departmentcode,
                    deptDesc: item?.departmentdesc
                }));
                setBasicDetailsOptions(() => ({
                    locationNameOptions,
                }));
            } catch (error) {
                console.log("Failed to fetch asset options:", error);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);

        }
    };



    return (
        <>
            <PageLoader open={isLoading} />
            <PageTitle title={"Asset Checkin"} />
            <Box mt={{ xs: 1, sm: 2 }}>

                <DefaultCard>
                    <Stack
                        mb={1}
                        direction={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                    >
                        <SectionTitle title={"Asset Checkin List"} />
                        <RefreshExportButtons
                            pagination={true}
                            exportFunction={() => { }}
                            exportData={rows}
                            refData={gridApi}
                            enableDownload={false}
                            handleRefresh={handleRefresh}
                        />
                    </Stack>

                    <DefaultCard sx={{ mt: 3 }}>
                        <CustomAgGrid
                            rows={rows}
                            columns={columns}
                            ref={gridApi}
                            setGridApi={setGridApi}
                            pagination={true}
                            isLoading={isLoading}
                        />
                    </DefaultCard>

                    <Box
                        sx={{
                            display: "flex",
                            gap: 2,
                            justifyContent: { xs: "center", md: "end" },
                            mt: 3,
                        }}
                    >
                        <Button variant='outlined' onClick={handleCancel}>Close</Button>

                    </Box>
                </DefaultCard>

                <Dialog
                    open={dialogOpen}
                    onClose={(event, reason) => {
                        if (reason !== "backdropClick") {
                            setDialogOpen(false);
                        }
                    }}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    fullWidth
                    maxWidth="md" // sm / md / lg based on how wide you want

                >
                    <PageLoader open={loading} />

                    <Box sx={{
                        p: 4, // Adjust padding as needed
                        width: "100%",
                        maxHeight: "120vh", // You can increase or remove this if you want more vertical space
                        overflowY: "auto",

                    }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom>
                                    New Department/Location Code
                                </Typography>
                            </Grid>
                            <Grid item xs={6} md={6} sm={3}>
                                <CustomTextField
                                    label="Old Asset No."
                                    id="old-assetNo"
                                    name="oldassetNo"
                                    disabled={true}
                                    placeholder={''}
                                    value={rowsid?.assetno || ''}
                                />
                            </Grid>


                            <Grid item xs={6} md={6} sm={3}>
                                <CustomTextFieldWithSearch
                                    label="Location Name"
                                    id="location-name"
                                    name="locationName"
                                    isMandatoryField={true}
                                    error={error?.locationName}
                                    errorMessage={errorMessage?.locationName}
                                    options={basicDetailsOptions?.locationNameOptions}
                                    value={basicDetailsdata?.locationName || ''}
                                    onChange={handleOnChange}
                                />
                            </Grid>

                            <Grid item xs={6} md={6} sm={3}>
                                <CustomTextField
                                    label="Work Group"
                                    id="work-Group"
                                    name="workGroup"
                                    disabled={true}
                                    placeholder={''}
                                    value={rowsid?.workgroupcode || ''}
                                />
                            </Grid>

                            <Grid item xs={6} md={6} sm={3}>
                                <CustomTextField
                                    label="Location Code"
                                    id="location-no"
                                    name="locationNo"
                                    disabled={true}
                                    placeholder={''}
                                    value={basicDetailsdata?.locationName?.locationCode || ''}
                                />
                            </Grid>
                            {/* Row 4 */}

                            <Grid item xs={6} md={6} sm={3}>
                                <CustomTextField
                                    label="Department Code"
                                    id="user-department"
                                    name="userDepartment"
                                    disabled={true}
                                    placeholder={''}
                                    value={basicDetailsdata?.locationName?.deptCode || ''}
                                    onChange={handleOnChange}
                                />
                            </Grid>
                            <Grid item xs={6} md={6} sm={3}>
                                <CustomTextField
                                    label="Department Description"
                                    id="department-description"
                                    name="departmentDescription"
                                    disabled={true}
                                    placeholder={''}
                                    value={basicDetailsdata?.locationName?.deptDesc || ''}
                                    onChange={handleOnChange}
                                />
                            </Grid>

                        </Grid>
                        <br />
                        <br />
                        <br />
                        <Box sx={{ display: 'flex', justifyContent: 'end', gap: 2, mb: 2 }}>

                            <Button variant="contained" color="primary" onClick={(rowData) => handleTransfer(rowData)}>
                                Create Asset
                            </Button>

                            <Button variant="outlined" onClick={handleDialogClose}>
                                Cancel
                            </Button>
                        </Box>
                    </Box>

                </Dialog>

                {/* Success Dialog */}
                <Dialog
                    open={openSuccessDialog}
                    onClose={(event, reason) => {
                        if (reason !== "backdropClick") {
                            handleCloseModel();
                        }
                    }}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle>Success</DialogTitle>
                    <DialogContent>
                        <Typography variant="body1">
                            Asset No. generated successfully. The new Asset No. is: <strong>{assetNo}</strong>
                        </Typography>
                        <Typography variant="body1">
                            Please click "Continue" to generate the PPM Planner for the new Asset No.
                        </Typography>
                    </DialogContent>

                    <DialogActions>
                        {/* Continue button that triggers the next step */}
                        <Button onClick={handlecontinue} color="primary" variant="contained">
                            Continue
                        </Button>
                        {/* OK button to close the dialog */}
                        <Button onClick={handleCloseModel} color="primary" variant="outlined">
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>


                <CustomDialog
                    open={errorDialogOpen}
                    onClose={(event, reason) => {
                        if (reason !== "backdropClick") {
                            ErrorDailogclose();
                        }
                    }}
                    content={dialogContent}
                    cancelBtn="Ok"
                />

            </Box>



        </>
    );

}
export default AssetCheckin;
